import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MondayLogo() {
    const size = 40;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                "clip-path": "url(#clip0_37408_407837)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.79401 51.14C6.40155 51.1378 5.03502 50.7632 3.83613 50.0549C2.63724 49.3466 1.64964 48.3306 0.975735 47.112C0.301828 45.8935 -0.0338486 44.5169 0.00351271 43.1249C0.040874 41.7329 0.449915 40.3763 1.18822 39.1957L15.2307 16.77C16.3292 15.0159 18.0795 13.77 20.0966 13.3064C21.0954 13.0769 22.1296 13.0463 23.1401 13.2165C24.1507 13.3866 25.1179 13.7541 25.9864 14.298C26.855 14.8419 27.6079 15.5516 28.2021 16.3865C28.7964 17.2214 29.2204 18.1651 29.45 19.1639C29.6795 20.1627 29.7101 21.1968 29.54 22.2074C29.3698 23.218 29.0023 24.1852 28.4584 25.0537L14.4126 47.4794C13.7107 48.6011 12.7349 49.5257 11.577 50.1661C10.4191 50.8065 9.11722 51.1417 7.79401 51.14Z",
                        fill: "#FF3D57"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M31.9939 51.14C30.6003 51.1401 29.2322 50.7671 28.0315 50.0598C26.8308 49.3524 25.8413 48.3366 25.1659 47.1176C24.4905 45.8987 24.1537 44.5212 24.1905 43.1281C24.2273 41.735 24.6364 40.3772 25.3752 39.1957L39.4274 16.77C39.9484 15.8557 40.649 15.0562 41.487 14.4197C42.325 13.7832 43.2832 13.3227 44.3037 13.0661C45.3243 12.8095 46.3862 12.762 47.4256 12.9264C48.4651 13.0908 49.4605 13.4639 50.352 14.023C51.2435 14.5821 52.0127 15.3158 52.6133 16.1799C53.2139 17.044 53.6335 18.0207 53.8469 19.0512C54.0602 20.0816 54.0629 21.1446 53.8548 22.1762C53.6467 23.2078 53.232 24.1865 52.6358 25.0537L38.6093 47.4794C37.9074 48.6011 36.9316 49.5257 35.7736 50.1661C34.6157 50.8065 33.3171 51.1417 31.9939 51.14Z",
                        fill: "#FFCB00"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M56.1873 51.1368C60.5036 51.1368 64.0026 47.7254 64.0026 43.5172C64.0026 39.309 60.5036 35.8976 56.1873 35.8976C51.871 35.8976 48.372 39.309 48.372 43.5172C48.372 47.7254 51.871 51.1368 56.1873 51.1368Z",
                        fill: "#00D647"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_37408_407837",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "64",
                        height: "64",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
